import React from 'react';
import {createPortal} from 'react-dom';
import PropTypes from 'prop-types';
import {useDispatch, useSelector} from 'react-redux';
import {Page} from '@adobe/aem-react-editable-components';
import ProductModal from '@/features/product/product-modal/components/ProductModal';
import CalciteLoader from '@/components/shared/CalciteLoader';
import CalciteScrim from '@/components/shared/CalciteScrim';
import i18nService from '@/services/i18n/i18n-service';
import {useProductPricing} from '@/features/product/hooks/useProductPricing';
import {
  closeProductModal,
  selectProductModalOpen,
  selectProductModalPaths,
  selectProductModalType,
  selectProductModalLabels,
  selectProductModalDefaultProductPath,
} from '@/features/product/product-modal/slices/product-modal-slice';
import {PRODUCT_TYPES} from '@/features/product/product-constants';

export const ProductModalSingleton = () => {
  const dispatch = useDispatch();
  const isOpen = useSelector(selectProductModalOpen);
  const productPaths = useSelector(selectProductModalPaths);
  const type = useSelector(selectProductModalType);
  const labels = useSelector(selectProductModalLabels);
  const defaultProductPath = useSelector(selectProductModalDefaultProductPath);
  const countryCode = type === PRODUCT_TYPES.TRAINING_VOUCHERS ? 'US' : null;
  const selectedZone = type === PRODUCT_TYPES.TRAINING_VOUCHERS ? 'US' : null;

  const {data: productData, isLoading, error} = useProductPricing(productPaths, countryCode, selectedZone);

  if (isOpen && isLoading) {
    return (
      <CalciteScrim>
        <CalciteLoader label={i18nService.t('Loading')} />
      </CalciteScrim>
    );
  }

  return createPortal(
    <ProductModal
      key={type}
      open={isOpen}
      onClose={() => dispatch(closeProductModal())}
      productData={productData}
      error={error}
      type={type}
      labels={labels}
      defaultProductPath={defaultProductPath}
    />,
    document.body,
  );
};

const App = (props) => {
  return (
    <>
      <Page {...props} />
      <ProductModalSingleton />
    </>
  );
};

App.propTypes = {
  cqChildren: PropTypes.object,
  cqItems: PropTypes.object,
  cqItemsOrder: PropTypes.arrayOf(PropTypes.string),
  cqPath: PropTypes.string,
  appWrapper: PropTypes.instanceOf(Element),
};

export default App;
